import React, { useRef } from 'react';
import { useIsScrollable } from '@shared/hooks/useIsScrollable';
import { ScrollableStatus } from '@shared/ui/ScrollableStatus/ScrollableStatus';
import { ScrollableContent } from '@shared/ui/ScrollableContent/ScrollableContent';
import { ScrollableHint } from '@shared/ui/ScrollableHint/ScrollableHint';
import styles from './AdditionalInformationSection.module.scss';

/**
 * @typedef {object} AdditionalInformationSectionProps
 * @property {string} additionalInformation
 */

/**
 * @param {AdditionalInformationSectionProps} props
 */
export const AdditionalInformationSection = props => {
  const { additionalInformation } = props;

  const contentRef = useRef(null);

  const isScrollable = useIsScrollable(contentRef, additionalInformation);

  return (
    <section className={styles.section}>
      <div className={styles.heading}>
        <h4 className={styles.title}>Additional Information</h4>
        {isScrollable && <ScrollableStatus />}
      </div>
      <ScrollableContent ref={contentRef}>{additionalInformation}</ScrollableContent>
      {isScrollable && <ScrollableHint />}
    </section>
  );
};
